import React from "react"
import cx from "classnames"
import {
  defaultRatingIcon,
  RatingIcon,
  RatingIconsPropsType,
} from "./RatingIcons"
import RatingLabel from "./RatingLabel"

type RatingCompactPropsType = Pick<
  RatingIconsPropsType,
  "className" | "value" | "size"
> & {
  icon?: JSX.Element
  count?: number
}

export function formatRatingValue(value: number) {
  return `${value}`.includes(".") ? value : value.toFixed(1)
}

export function RatingCompact({
  className,
  value,
  count,
  size = 16,
  icon = defaultRatingIcon,
}: RatingCompactPropsType) {
  return (
    <div className={cx("cobalt-rating", className)}>
      <RatingIcon icon={icon} size={size} status={"full"} />
      <RatingLabel>
        {formatRatingValue(value)} {count && `(${count})`}
      </RatingLabel>
    </div>
  )
}
